import { IonCol, IonContent, IonGrid, IonPage, IonRow, IonText } from "@ionic/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ReportSelector } from "./components/ReportSelector";
import { Toolbar } from "./components/Toolbar";
import { setInitialData } from "../../store/attendance";
import { SyncSelector } from "./components/SyncSelector";

const colStyle = {
    maxWidth: "450px",
    padding: "20px"
};

const rowStyle = {
    marginTop: "20px"
};

export const Attendance = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setInitialData());
    }, [dispatch]);

    return (
        <IonPage>
            <Toolbar />
            <IonContent>
                <IonGrid fixed={true} style={{ height: "100%" }}>
                    <IonRow class="ion-justify-content-center">
                        <IonText class="ion-text-center">
                            <h4>ACCESO A LA INFORMACIÓN DISPONIBLE ALMACENADA</h4>
                        </IonText>
                    </IonRow>
                    <IonRow class="ion-justify-content-around">
                        <IonCol class="ion-text-center" style={colStyle}>
                            <ReportSelector />
                        </IonCol>
                    </IonRow>
                    <IonRow class="ion-justify-content-around" style={rowStyle}>
                        <IonCol class="ion-text-center" style={colStyle}>
                            <SyncSelector />
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};
